import * as React from 'react'
import { Box, Typography } from '@mui/material'
import { formatCurrency, formatNumber } from 'utils/formatters'

/**
 * Statistics component
 */
const Statistics = ({ stats }) => {
  const rows = []

  for (let i = 0; i < stats.length; i += 3) {
    rows.push(stats.slice(i, i + 3))
  }

  return (
    <Box
      sx={{
        my: 6,
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        overflow: 'hidden',
        displayPrint: 'none',
      }}
    >
      {rows.map((row, rowIndex) => (
        <Box
          key={rowIndex}
          sx={{
            display: 'grid',
            gridTemplateColumns: `repeat(${row.length}, minmax(0, 1fr))`,
            borderBottom: rowIndex !== rows.length - 1 ? 1 : 0,
            borderColor: 'divider',
          }}
        >
          {row.map((stat, i) => (
            <Box
              key={i}
              sx={{
                p: 2,
                bgcolor: 'white',
                borderRight: i !== row.length - 1 ? 1 : 0,
                borderColor: 'divider',
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 'fontWeightMedium', textTransform: 'uppercase' }} gutterBottom>
                {stat.label}
              </Typography>

              <Typography variant="h4">
                {stat.label === 'Total Revenue' ? formatCurrency(stat.value, { fromCents: true }) : formatNumber(stat.value)}
              </Typography>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  )
}

export default Statistics
